import React, {useState} from 'react';
import { SearchBarStyle } from '../../../../styles/common';
import styled, { css } from 'styled-components';
import theme from '../../../../styles/theme';

import { useGetItemHistSel, useGetItemSel } from '../../../../interface/item';

import moment from 'moment';
import Button from '../../../common/Button';
import FullModal from '../../../common/modal/FullModal';
import AssetItem from './AssetItem';
import { useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField, Fade } from '@mui/material';


import { useGetCategoryList, useGetStatusList } from '../../../../interface/common';
import CommonDataGrid from '../../../common/CommonDataGrid';
import { NumericFormat } from 'react-number-format';
import { TreeItem, TreeView } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NaviText from '../../common/NaviText';
import { useLocation } from 'react-router-dom';
import { DEPT_CD } from '../../../common/constants';
import { useQuery } from 'react-query';


const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    display: flex;
    flex-direction: column;
    
    div {
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const TabText = styled.h3`
    display: inline-box;
    font-size: ${theme.fontSize.base};
    font-weight: 600;
    // width: calc(100% - 24px);
    margin: 0;
    ${(props)=> props.selected === true ? activeSpan : nonActiveSpan};
    transition : all 0.3s ease-in-out;
`
const activeSpan = css`
    color: ${theme.color.black[80]};
    border-bottom: 1px solid ${theme.color.black[80]};
`;
const nonActiveSpan = css`
    color: ${theme.color.black[40]};
`;

const NumericFormatCustom = (param) => {
    return (
        <NumericFormat
        type='text'
        displayType='text'
        thousandSeparator
        isNumericString
        prefix="₩ "
        value={param.row.pur_price}
      />
    )
}

const MFadePannel = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    border: 0;
    position: fixed;
    top: 0;
    left: 0;
    background: ${theme.color.black[60]};
    border-radius: 16px;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    > .pannel {
        position: relative;
        background: ${theme.color.white[100]};
        width: 340px;
        max-height: calc(80% - 80px);
        height: auto;
        padding: 16px;
        padding-top: 0;
        border-radius: inherit;
        overflow-y: auto;
    }
    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }
`;

const columns = [
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'pcat_nm', headerName: '구분', width:100 },
    { field: 'cat_nm', headerName: '분류', width:150 },
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'r_item', headerName: '연계자산', width:200 },
    { field: 'status_nm', headerName: '자산상태', width:100 },
    { field: 'b_cnt', headerName: '고장횟수', width:120 },
    { field: 's_use_cnt30', headerName: '최근30일사용횟수', width:120 },
    { field: 's_use_cnt60', headerName: '최근60일사용횟수', width:120 },
    { field: 'tid', headerName: 'QRCODE', width:120, valueGetter: (param) => `TAMS${param.row.tid}` },
    { field: 'model_nm', headerName: '모델명', width:300 },
    { field: 'maf_nm', headerName: '제조사', width:100 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'location', headerName: '위치', width:120 },
    { field: 'serial_no', headerName: '시리얼넘버', width:200 },
    { field: 'maf_date', headerName: '제조일자', width:100 },
    { field: 'pur_date', headerName: '구매일자', width:100 },
    { field: 'pur_tpnm', headerName: '구매구분', width:100 },
    { field: 'pur_price', headerName: '구매가격', width:120, renderCell:NumericFormatCustom},
    { field: 'uid1_nm', headerName: '책임자', width:100 },
    { field: 'uid2_nm', headerName: '부책임자', width:100 },
]

const histColumns = [
    { field: 'reg_dt', headerName: '일시', flex:1 },
    { field: 'mod_tpnm', headerName: '변경내용', flex:0.5 },
    { field: 'mod_stnm', headerName: '결과', flex:0.5 },
]

const ItemsMain = () => {

    const {state} = useLocation();
    const { data : user } = useQuery('ADMIN_USER_INFO', {});

    const [searchStatus,setSearchStatus] = useState(state && 'B');
    const [searchCid,setSearchCid] = useState(state ? {...state} : DEPT_CD.TS === user.dept_cd ? {cid:5,cat_nm:'조사장비'} : {cid:'',cat_nm:''});
    const [regOpen, setRegOpen] = useState(false);
    const [target, setTarget] = useState();

    const [list, setList] = useState([]);
    const [histList, setHistList] = useState([]);
    const [tab, setTab] = useState('INFO');

    const [toggle,setToggle] = useState(false);
    const [categoryTree, setCategoryTree] = useState();

    const {data : categoryList} = useGetCategoryList();
    const {data : statusList} = useGetStatusList();
    const {data, isLoading, refetch } = useGetItemSel({status:searchStatus, cid: searchCid.cid});
    const {data : itemHist, refetch: histRefetch} = useGetItemHistSel({});

    const handleSelectCategory = (pp) => {
        if(pp){
            setSearchCid(pp)
        }
    }

    const handleCategoryDoubleClick = () => {
            setToggle(false);
    }

    // useEffect(()=>{
    //     if(state && state.cid){
    //         setSearchCid(state);
    //         setSearchStatus('B')
    //     }
    // },[state])

    useEffect(()=>{
        refetch();
    },[searchCid.cid, searchStatus])

    useEffect(()=>{
        if(regOpen === false){
            histRefetch();
        }
    },[regOpen])

    useEffect(()=>{
        if(data){
            setList(data.map((item,index)=>(
                                    {
                                        ...item,
                                        id:index,
                                        r_item: 
                                                item.r_tno === null ? 
                                                (item.s_tno !== null) ? (item.s_tno +' | '+ ((item.s_lot_no !== null && item.s_lot_no) !== '' ? item.s_lot_no : '-')) : '-'
                                                : 
                                                (item.r_tno !== null) ? (item.r_tno +' | '+ ((item.r_lot_no !== null && item.r_lot_no) !== '' ? item.r_lot_no : '-')) : '-' ,
                                        maf_date: item.maf_date ? moment(item.maf_date).format('YYYY/MM/DD') : '',
                                        pur_date: item.pur_date ? moment(item.pur_date).format('YYYY/MM/DD') : ''
                                    }
                                )));
        }else{
            setList([])
        }
    },[data])

    useEffect(()=>{
        if(itemHist){
            setHistList(itemHist.map((item,index)=>({
                ...item,
                id:index,
                reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm')})
                ));
        }else{
            setHistList([])
        }
    },[itemHist])

    useEffect(()=>{
        const arrayToTree = (arr, parent = null) =>
                    arr.filter(item => item.pcid === parent)
                    .map(child => ({ ...child, children: arrayToTree(arr, child.cid) }));
        if(categoryList && categoryList[0]) {
            setCategoryTree(arrayToTree(categoryList[0]));
        }
    },[categoryList])

    return (
        <MainWrap>
            {/* <TabText selected={tab==='INFO'} onClick={()=>setTab('INFO')}>자산 목록</TabText>&nbsp;&nbsp;
            <TabText selected={tab==='HIST'} onClick={()=>setTab('HIST')}>이력</TabText> */}
                <div>
                    <Fade in={toggle}>
                        <MFadePannel>
                            <div className='pannel'>
                                <div className='naviBar' >
                                    <NaviText target={[{text:'자산관리'},{text:'자산목록'}, {text:'분류 선택'}]} />
                                    <div className='close' style={{top:'24px',right:'16px'}} onClick={()=>setToggle(false)}>
                                        <img src={`/images/ic_close.svg`} />
                                    </div>
                                </div>
                                <div style={{height:'16px'}} />
                                {categoryTree &&
                                    <TreeView
                                        aria-label="rich object"
                                        defaultCollapseIcon={<ExpandMoreIcon />}
                                        defaultExpanded={['root']}
                                        defaultExpandIcon={<ChevronRightIcon />}
                                        sx={{ flexGrow: 1, maxWidth: 200}}
                                    >
                                        <TreeItem nodeId={''} label={'전체'} onClick={()=>handleSelectCategory({cid:'',cat_nm:''})}></TreeItem>
                                        {categoryTree && categoryTree.map((item,index)=>{
                                            return renderTree(item,handleSelectCategory,handleCategoryDoubleClick)
                                        })}
                                    </TreeView>
                                }
                            </div>
                        </MFadePannel>
                    </Fade>
                    <SearchBarStyle>
                        <div style={{display:'flex',gap: '1rem',flexWrap:'wrap', justifyContent:'flex-start', alignItems:'center'}}>
                            <FormControl style={{width:'10rem'}} size='small'>
                                <InputLabel id='status-label'>자산상태</InputLabel>
                                <Select label="자산상태" labelId='status-label' size='small' value={searchStatus}>
                                    <MenuItem value={''} onClick={()=>setSearchStatus('')} >없음</MenuItem>
                                    {statusList && statusList.map((item,index)=>{
                                        return <MenuItem 
                                                    key={index} 
                                                    value={item.code} 
                                                    onClick={()=>setSearchStatus(item.code)}
                                                >
                                                    {item.value}
                                                </MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                            <TextField
                                label='분류'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                placeholder='분류선택'
                                style={{width:'8.5rem'}}
                                value={searchCid ? searchCid.cat_nm : ''}
                                // defaultValue={rItem && rItem[0].tno}
                                onClick={()=>setToggle(true)}
                            />
                            {/* <TextField 
                                id='sdate'
                                label='등록일자(FROM)' 
                                style={{width:'10rem'}} 
                                InputLabelProps={{shrink:true}} 
                                type='date' 
                                size='small' 
                                onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                            />
                            ~
                            <TextField 
                                id='edate'
                                label='등록일자(TO)' 
                                style={{width:'10rem'}} 
                                InputLabelProps={{shrink:true}} 
                                type='date' 
                                size='small' 
                                onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                            /> */}
                        </div>
                        <div>
                           <h4>QR코드번호는 자산 등록 시 자동 생성됩니다. 생성된 QR코드번호를 확인 후 라벨링하세요.</h4>
                        </div>
                        <div style={{display:'flex',flexWrap:'wrap', justifyContent:'flex-end', alignItems:'center'}}>
                            {/* <Button onClick={goSearch} style={{width:'120px'}}>검색</Button> */}
                            <Button onClick={()=>{setTarget();setRegOpen(true)}} style={{width:'120px'}}>등록</Button>
                        </div>
                    </SearchBarStyle>
                </div>
                <div style={{width:'100%', height: '80vh'}}>
                    <CommonDataGrid
                        isLoading={isLoading}
                        list={list}
                        columns={columns}
                        checkBox={true}
                        // showCount={100}
                        onRowClick={(e)=>{setTarget(e.row);setRegOpen(true)}}
                        />
                </div>
            
            <FullModal open={regOpen}>
                <DetailWrap target={target} onClose={setRegOpen} />
            </FullModal>
        </MainWrap>
    )

}

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;

const DetailWrap = ({target, onClose}) => {
    return (
        <DetailWrapStyle>
            <AssetItem item={target} onClose={onClose}/>
        </DetailWrapStyle>
    )
}

const renderTree = (nodes,getItem,handleCategoryDoubleClick) => {
    const handleClick = () => {
        getItem(nodes)
    }
    const handleDoubleClick = () => {
        handleCategoryDoubleClick()
    }
    return (
    <TreeItem key={nodes.cid} nodeId={nodes.cid} label={nodes.cat_nm} onClick={handleClick} onDoubleClick={handleDoubleClick}>
    {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node, getItem, handleCategoryDoubleClick))
        : null}
    </TreeItem>
    )
}


export default ItemsMain;